import { handleUploadImageToS3 } from "./UploadImageToS3";
import { filterObject } from "./FilterObject";
import { minutesToDuration } from "./minutesToDuration";
import { dateInArray } from "./dateInArray";
import { findZipcode } from "./findZipcode";

const cutString = (text, count, insertDots) => {
  return text ? text.slice(0, count) + (((text.length > count) && insertDots) ? "..." : "") : "";
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function getInitials(fullName) {
  return fullName
    .split(' ') // Split by space
    .map(word => word.charAt(0).toUpperCase()) // Get first letter and capitalize
    .join(''); // Join letters
}

const onContactClick = () => {
  const number = "+31680068100".replace(/[^\w\s]/gi, "").replace(/ /g, "");
  // window.open(`https://web.whatsapp.com/send?phone=${number}`);
  window.location.href = `whatsapp://send?phone=${number}`;             // try desktop app
  setTimeout(() => (window.open(`https://wa.me/${number}`)), 1200);
};

export const openWhatsapp = (number) => {
  // window.open(`https://web.whatsapp.com/send?phone=${number}`);
  window.location.href = `whatsapp://send?phone=${number}`;             // try desktop app
  setTimeout(() => (window.open(`https://wa.me/${number}`)), 1200);
};

function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

function isUrlValid(str) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
  );
  return pattern.test(str);
}

function checkSocialUrl(profile, str) {
  let regexp = {
    email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/,
    facebook: /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i,
    instagram: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/([A-Za-z0-9-_]+)/im,
    youtube: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/img,
    linkedIn: /^https:\/\/[a-z]{2,3}\.linkedin\.com\/.*$/gim,
    twitter: /^(https?:\/\/)?((w{3}\.)?)twitter\.com\/(#!\/)?[a-z0-9_]+$/i,
  }

  const pattern = new RegExp(regexp[profile]);
  return pattern.test(str);
}

function wrapContentIfNeeded(html) {
  // const trimmed = html.trim();
  // if (!trimmed.startsWith('<')) {
  //   return `<p>${trimmed}</p>`;
  // }
  return html;
}

function getInitialsUrl(name) {
  // getInitials(name)
  return `https://ui-avatars.com/api/?background=0D8ABC&color=fff&size=128&name=${encodeURI(name)}`;
}

function isUnixTimestamp(value) {
  if (typeof value !== "number") return false;

  // Seconds-based Unix timestamp is usually 10 digits long
  // Milliseconds-based Unix timestamp is 13 digits long
  const length = value.toString().length;

  return length === 10 || length === 13;
}

function isValidDateString(value) {
  const date = new Date(value);
  return !isNaN(date.getTime());
}

function detectDateType(value) {
  if (typeof value === 'number') {
    const len = value.toString().length;
    if (len === 10) return 'unix-seconds';
    if (len === 13) return 'unix-milliseconds';
    return 'unknown-number';
  } else if (typeof value === 'string' && isValidDateString(value)) {
    return 'date-string';
  }
  return 'invalid';
}

function getRootDomain() {
  const parts = window.location.hostname.split(".");
  if (parts.length > 2) {
    // Handles subdomain.example.com
    return parts.slice(-2).join(".");
  }
  return window.location.hostname;
}

export function createBusinessDomain(link) {
  const parts = window.location.hostname.split(".");
  if (parts.length > 2) {
    // Handles subdomain.example.com
    return `https://${link ? link + "." : ""}${parts.slice(-2).join(".")}/`;
  }
  return `https://${link ? link + "." : ""}${window.location.hostname}/`;
}

export function pct(n, d) {
  if (!d) return 0;
  return Math.round((n / d) * 100);
}

export function getUsedSubscriptionPercentage(startTimestamp, endTimestamp) {
  const now = Math.floor(Date.now() / 1000); // current time in seconds

  if (now < startTimestamp) return 0;
  if (now >= endTimestamp) return 100;

  const totalDuration = endTimestamp - startTimestamp;
  const elapsed = now - startTimestamp;

  return Math.round((elapsed / totalDuration) * 100);
}

function getRandomHexColor() {
  return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
}

export {
  handleUploadImageToS3,
  filterObject,
  minutesToDuration,
  dateInArray,
  findZipcode,
  cutString,
  classNames,
  getInitials,
  onContactClick,
  isValidEmail,
  isUrlValid,
  checkSocialUrl,
  wrapContentIfNeeded,
  getInitialsUrl,
  isUnixTimestamp,
  isValidDateString,
  detectDateType,
  getRootDomain,
  getRandomHexColor,
};
